import React from 'react';
import { SEO } from '../components/SEO';
export function DatenschutzPage() {
  return <>
      <SEO title="Datenschutzerklärung - CRM Kraft | Justus Kraft" description="Datenschutzerklärung von CRM Kraft. Informationen zur Datenerfassung, Verarbeitung und Ihren Rechten gemäß DSGVO." keywords="Datenschutz, DSGVO, Datenschutzerklärung, CRM Kraft, Justus Kraft" ogType="website" data-id="element-331" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-332">
        <div className="max-w-4xl mx-auto" data-id="element-333">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-334">
            Datenschutzerklärung
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-335">
            <section className="mb-8" data-id="element-336">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-337">
                1. Datenschutz auf einen Blick
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-338">
                Allgemeine Hinweise
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-339">
                Die folgenden Hinweise geben einen einfachen Überblick darüber,
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
                Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-340">
                Datenerfassung auf dieser Website
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-341">
                <strong className="text-white" data-id="element-342">
                  Wer ist verantwortlich für die Datenerfassung auf dieser
                  Website?
                </strong>
                <br data-id="element-343" />
                Die Datenverarbeitung auf dieser Website erfolgt durch den
                Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum
                dieser Website entnehmen.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-344">
                <strong className="text-white" data-id="element-345">
                  Wie erfassen wir Ihre Daten?
                </strong>
                <br data-id="element-346" />
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
                mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie
                in ein Kontaktformular eingeben. Andere Daten werden automatisch
                oder nach Ihrer Einwilligung beim Besuch der Website durch
                unsere IT-Systeme erfasst.
              </p>
            </section>

            <section className="mb-8" data-id="element-347">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-348">
                2. Hosting
              </h2>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-349">
                Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-350">
                Die Server befinden sich in Deutschland. Weitere Informationen
                entnehmen Sie der Datenschutzerklärung des Hosting-Anbieters.
              </p>
            </section>

            <section className="mb-8" data-id="element-351">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-352">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-353">
                Datenschutz
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-354">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
                Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
                vertraulich und entsprechend den gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-355">
                Hinweis zur verantwortlichen Stelle
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-356">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser
                Website ist:
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-357">
                Justus Kraft
                <br data-id="element-358" />
                CRM Kraft
                <br data-id="element-359" />
                Musterstraße 123
                <br data-id="element-360" />
                12345 Musterstadt
                <br data-id="element-361" />
                Deutschland
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-362">
                E-Mail: kontakt@crmkraft.de
                <br data-id="element-363" />
                Telefon: +49 (0) 123 456789
              </p>
            </section>

            <section className="mb-8" data-id="element-364">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-365">
                4. Datenerfassung auf dieser Website
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-366">
                Cookies
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-367">
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies
                sind kleine Textdateien und richten auf Ihrem Endgerät keinen
                Schaden an. Sie werden entweder vorübergehend für die Dauer
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente
                Cookies) auf Ihrem Endgerät gespeichert.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-368">
                Server-Log-Dateien
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-369">
                Der Provider der Seiten erhebt und speichert automatisch
                Informationen in so genannten Server-Log-Dateien, die Ihr
                Browser automatisch an uns übermittelt. Dies sind:
              </p>
              <ul className="list-disc list-inside text-[#94A3B8] leading-relaxed mb-4 space-y-2" data-id="element-370">
                <li data-id="element-371">Browsertyp und Browserversion</li>
                <li data-id="element-372">verwendetes Betriebssystem</li>
                <li data-id="element-373">Referrer URL</li>
                <li data-id="element-374">Hostname des zugreifenden Rechners</li>
                <li data-id="element-375">Uhrzeit der Serveranfrage</li>
                <li data-id="element-376">IP-Adresse</li>
              </ul>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-377">
                Eine Zusammenführung dieser Daten mit anderen Datenquellen wird
                nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf
                Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-378">
                Kontaktformular
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-379">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                werden Ihre Angaben aus dem Anfrageformular inklusive der von
                Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
                Anfrage und für den Fall von Anschlussfragen bei uns
                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
                weiter.
              </p>
            </section>

            <section className="mb-8" data-id="element-380">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-381">
                5. Ihre Rechte
              </h2>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-382">
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft über
                Ihre gespeicherten personenbezogenen Daten, deren Herkunft und
                Empfänger und den Zweck der Datenverarbeitung sowie ein Recht
                auf Berichtigung oder Löschung dieser Daten.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-383">
                Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten
                können Sie sich jederzeit an uns wenden.
              </p>
            </section>

            <section className="mb-8" data-id="element-384">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-385">
                6. Analyse-Tools und Tools von Drittanbietern
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-386">
                Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
                ausgewertet werden. Das geschieht vor allem mit sogenannten
                Analyseprogrammen. Detaillierte Informationen zu diesen
                Analyseprogrammen finden Sie in der folgenden
                Datenschutzerklärung.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}